import React from 'react';
import mergeRefs from 'react-merge-refs';
import IconCheckmark from '../../icons/icon_checkmark';
import IconX from '../../icons/icon_x';
import useFocusVisible from '../../utils/use_focus_visible';
import useStyles from './use_styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Option = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    highlightedRef,
    isHighlighted = false,
    isSelected = false,
    multiple = false,
    onClick,
    onKeyDown,
    onKeyPress,
    onMouseDown,
    onMouseMove,
    option
  } = _ref;
  var [focusVisible, setFocusVisible] = React.useState(false);
  var {
    handleBlurVisible,
    handleFocusVisible,
    ref: focusVisibleRef
  } = useFocusVisible();
  var optionRef = React.useRef();
  var refs = [optionRef, ref, focusVisibleRef];
  if (isHighlighted && highlightedRef) refs.push(highlightedRef);
  var handleOptionRefs = mergeRefs(refs);
  var {
    divider,
    label,
    value
  } = option;
  var optionIcon = multiple && isSelected && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(IconCheckmark, {
    className: "icon_checkmark"
  }), ___EmotionJSX(IconX, {
    className: "icon_x"
  }));
  var handleBlur = React.useCallback(event => {
    if (focusVisible) {
      setFocusVisible(false);
      handleBlurVisible(event);
    }
  }, [focusVisible, handleBlurVisible]);
  var handleFocus = React.useCallback(event => {
    if (handleFocusVisible(event)) {
      setFocusVisible(true);
    }
  }, [handleFocusVisible]);
  var handleMouseMove = React.useCallback(event => {
    if (focusVisible) {
      setFocusVisible(false);
    }
    onMouseMove === null || onMouseMove === void 0 || onMouseMove(event, option);
  }, [focusVisible, onMouseMove, option]);
  var handleMouseDown = React.useCallback(event => {
    if (focusVisible) {
      setFocusVisible(false);
    }
    onMouseDown === null || onMouseDown === void 0 || onMouseDown(event, option);
  }, [focusVisible, onMouseDown, option]);
  var handleClick = React.useCallback(event => onClick === null || onClick === void 0 ? void 0 : onClick(event, option), [onClick, option]);
  var handleKeyDown = React.useCallback(event => onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event, option), [onKeyDown, option]);
  var styles = useStyles();
  if (divider) {
    return ___EmotionJSX("span", {
      className: "label-small vn-option__divider",
      role: "separator"
    }, value);
  }
  return ___EmotionJSX("li", {
    "aria-selected": isSelected,
    css: styles,
    "data-value": label || value,
    onBlur: handleBlur,
    onClick: handleClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyPress: onKeyPress,
    onMouseDown: handleMouseDown,
    onMouseMove: handleMouseMove,
    ref: handleOptionRefs,
    role: "option",
    tabIndex: 0
  }, optionIcon, label || value);
});
Option.displayName = 'Option';
export default Option;